import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';
import { areAllFacetsUnchecked } from '../../../../lib/facetHelpers';
import { SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS } from '../grid/SurveyLibraryGridCreate';

const nameSpace = 'SURVEY_LIBRARY';
const SURVEY_LIBRARY_SET_CURRENCY = 'SURVEY_LIBRARY_SET_CURRENCY';
const RESET_SURVEY_LIBRARY_REDUCER = 'RESET_SURVEY_LIBRARY_REDUCER';

const initialState = {
  filtersAreOpen: false,
  facetSelection: {},
  facets: [],
  loading: false,
  loaded: true,
  error: null,
  items: [],
  query: '',
  include: {},
  exclude: {},
  showAddButton: true,
  resetFacetText: 'Reset Filters',
  filters: {},
  facetIsCheckedByDefault: false,
  showZeros: false,
  sortBy: 'label',
  offset: 0,
  limit: 50,
  currency: '%'
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.marketPricing.SurveyLibraryReducer.SurveyLibraryFacetReducer,
  useCMS: true,
  // eslint-disable-next-line no-unused-vars
  genericGridParams: state => {
    const { facetSelection, facets, query } = state.marketPricing.SurveyLibraryReducer.SurveyLibraryFacetReducer;

    // Show 'Reset All' button in facet panel header if any options are unselected in facet panel
    const anyFacetsUnselected = areAllFacetsUnchecked(facets, facetSelection);
    const showResetAllButton = !anyFacetsUnselected || (query && query !== '');
    return {
      currency: state.marketPricing.SurveyLibraryReducer.SurveyLibraryFacetReducer.currency,
      benchmarkYears: [state.marketPricing.JobPricingReducer.MainJobPricingReducer.selectedBenchmarkYear],
      displayIn: state.marketPricing.MarketPricingReducer.displayIn,
      appendSurveyYear: false,
      getDefaultDataCuts: true,
      limitSubscribedSurveys: true,
      returnResults:
        !!showResetAllButton ||
        state.marketPricing.SurveyLibraryReducer.SurveyLibraryGridReducer.searchMode === 'advanced',
      addedFilters: state.marketPricing.SurveyLibraryReducer.SurveyLibraryGridReducer.addedFilters,
      orderBy: state.marketPricing.SurveyLibraryReducer.SurveyLibraryGridReducer.orderBy
    };
  }
};

export const surveyFacetSearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    case SURVEY_LIBRARY_SET_CURRENCY:
      return {
        ...state,
        currency: action.currency
      };
    case RESET_SURVEY_LIBRARY_REDUCER:
      return { ...surveyFacetSearch.getInitialStateCopy(nameSpace, initialState), currency: state.currency };
    case SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS:
      return {
        ...state,
        loading: false,
        loaded: true
      };
    default:
      return null;
  }
}

export default surveyFacetSearch.createReducer(extendReducer, {
  searchAPI: '/cms/api/accounts/{{masterAccountId}}/survey-jobs'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const surveyLibraryFacetActions = surveyFacetSearch.getActions();

surveyLibraryFacetActions.setCurrency = currency => {
  return async dispatch => {
    return dispatch({
      type: SURVEY_LIBRARY_SET_CURRENCY,
      currency: currency || '%'
    });
  };
};

surveyLibraryFacetActions.resetSurveyLibraryReducer = () => {
  return { type: RESET_SURVEY_LIBRARY_REDUCER };
};
